import React from 'react'
import { BASE_URL } from '../utils/apiPaths'

const AvatarGroup = ({avatars,maxVisible = 3}) => {
  return (
    <div className="flex items-center">
        {avatars.slice(0,maxVisible).map(
            (avatar,index)=>( 
                <img
                key={index}
                src={`${BASE_URL}${avatar}`}
                alt={`Avatar ${index}`}
                className="w-9 h-9 rounded-full border-2 border-white -ml-2 first:ml-0"
                /> ))}
                {avatars.length > maxVisible && (
                    <div className="w-9 h-9 rounded-full border-2 border-white -ml-2 first:ml-0 bg-gray-200 flex items-center justify-center text-xs text-gray-600">
                        +{avatars.length - maxVisible}
                    </div>
                )}
    </div>
  )
}

export default AvatarGroup